import { ReactElement } from 'react'

const Modal = ({
  open,
  isNav = false,
  width = 'w-1/2',
  children,
}: {
  open: boolean
  isNav?: boolean
  width?: string
  children: ReactElement | string
}) =>
  open && (
    <div
      className='flex justify-center items-center fixed z-20 left-0 top-0 w-full h-screen overflow-auto'
      style={{ background: 'rgba(0, 0, 0, 0.5)' }}
    >
      {isNav ? (
        <div className='w-full'>{children}</div>
      ) : (
        <div
          className={`bg-beige w-[90%] md:${width} p-4 max-h-[90%] overflow-auto`}
        >
          {children}
        </div>
      )}
    </div>
  )

export default Modal
